import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../../layout/breadcrumb";

import StepZilla from "react-stepzilla";
import { Container, Row, Col, Card, CardHeader, CardBody, Label, span, Button } from "reactstrap";
import GSTN from "./kyc-components/gstn/gstn";
import PAN from "./kyc-components/pan/pan";
import BankDetails from "./kyc-components/bank-details/bank-details";
import Aadhar from "./kyc-components/aadhar/aadhar";
import FirstLoginTour from "../../../utilities/firrstLoginTour";
import Tour from 'reactour';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { toast } from "react-toastify";
import { getDealerById } from "../../../api";
const tourSteps = [
  {
    selector: '.step1',
    content: 'This is document needed for kyc',
  },
  {
    selector: '.step2',
    content: 'update the document',

  },
  {
    selector: '.step3',
    content: 'view the document file',
  },
  {
    selector: '.step4',
    content: 'this is where you can see document status ',
  },
]

const KYCBackup = (props) => {

  

  const [opentour, setopentour] = useState(FirstLoginTour());
  const [dealershipData, setDealershipData] = useState({});

  const [completionPercentage, setcompletionPercentage] = useState(0);
  const [completionSteps, setcompletionSteps] = useState(0);
  // const [startAtStep, setstartAtStep] = useState(0);
  const [myStep, setmyStep] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const closeTour = () => {
    setopentour(false);
  };

  const refreshKyc = () => {
    if (!refresh) {
      setRefresh(true)
    } else {
      setRefresh(false)
    }
  }

  const disableBody = target => disableBodyScroll(target);
  const enableBody = target => enableBodyScroll(target);

  const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }


  const fetchDealershipKycDetails = async () => {

    let dealerId = JSON.parse(localStorage.getItem('user')).dealer_code;
    if (dealerId) {
      // getDealershipKycDetails - Vinod's API call
      await getDealerById(dealerId).then((res) => {
        calculatePercenatgeCompletionMetrics(res.data.result);
        setDealershipData(res.data.result)
      }).catch((err) => {
        toast.error(err.response.data.error);
      })
    }

  }

  const calculatePercenatgeCompletionMetrics = async (data) => {
    let completionpercentageValue = 0;
    let completionSteps = 0;
    // let startAtStep = 0;
    
    if (data?.dealership_kyc_detail) {
      if (data.dealership_kyc_detail.is_pan_verified) {
        completionpercentageValue = completionpercentageValue + 25;
        completionSteps = completionSteps + 1;
      }
      if (data.dealership_kyc_detail.is_gstn_verified) {
        completionpercentageValue = completionpercentageValue + 25;
        completionSteps = completionSteps + 1;
      }
      if (data.dealership_kyc_detail.bank_account_number) {
        completionpercentageValue = completionpercentageValue + 25;
        completionSteps = completionSteps + 1;
      }

      if (data.dealership_kyc_detail.is_signatory_aadhar_verified && data.dealership_kyc_detail.is_signatory_pan_verified) {
        completionpercentageValue = completionpercentageValue + 25;
        completionSteps = completionSteps + 1;
      }

    }
    setmyStep(completionSteps)
    setcompletionPercentage(completionpercentageValue);
    setcompletionSteps(completionSteps);
  }



  useEffect(async () => {
    fetchDealershipKycDetails();

    if (props.uploadKyc) {

      const kycUploadSection = document.querySelector(".kycUploadSection");
      if (kycUploadSection) {
        kycUploadSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }

    }

  }, [refresh, props.uploadKyc]);

  useEffect(async () => {

  }, [completionSteps]);

  return (
    <Fragment>
      <Breadcrumb parent="Documents" title="KYC" />
      <Tour
        steps={tourSteps}
        rounded={5}
        isOpen={opentour}
        disableInteraction={true}
        disableKeyboardNavigation={false}
        onRequestClose={closeTour}
        onAfterOpen={disableBody}
        lastStepNextButton={<Button variant="secondary" size="xs" onClick={topFunction}>End tour</Button>}
        onBeforeClose={enableBody}
      />
      <Container fluid={true}>
        <Row>
          <Col xl="12" className="step1 pull-left" data-intro=" ">
            <Card>
              <CardHeader className="header_with_low_padding">
                <h6>DEALERSHIP DETAILS</h6>
              </CardHeader>
              <CardBody className="step2 body_with_low_padding" data-intro="Dealership Details">
                <Col xl='6' className=" pull-left">
                  <Col md='12'>
                    <Label><b>{"Name:"}</b></Label>
                    <span className="pull-right">{dealershipData.dealer_name}</span>
                  </Col>
                  <Col md='12'>
                    <Label><b>{"Location:"}</b></Label>
                    <span className="pull-right">{"--------------"}</span>
                  </Col>
                  <Col md='12'>
                    <Label><b>{"State:"}</b></Label>
                    <span className="pull-right">{dealershipData.state}</span>
                  </Col>
                  <Col md='12'>
                    <Label><b>{"Pincode:"}</b></Label>
                    <span className="pull-right">{dealershipData.pin_code}</span>
                  </Col>
                </Col>

                <Col xl='6' className=" pull-left">
                  <Col md='12'>
                    <Label><b>{"Entity Type:"}</b></Label>
                    <span className="pull-right">{"------------"}</span>
                  </Col>
                  <Col md='12'>
                    <Label><b>{"City:"}</b></Label>
                    <span className="pull-right">{dealershipData.city}</span>
                  </Col>
                  <Col md='12'>
                    <Label><b>{"Contact Number:"}</b></Label>
                    <span className="pull-right">{dealershipData.phone_number}</span>
                  </Col>
                  <Col md='12'>
                    <Label><b>{"Address:"}</b></Label>
                    <span className="pull-right">{dealershipData.address}</span>
                  </Col>
                </Col>

              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row >
          <Col xl="12" className="step1 pull-left" data-intro=" ">
            <Card>
              <CardHeader className="header_with_low_padding">
                <h6>KYC DOCUMENTS</h6>
                {/* <span className="pull-left">Documents: {completionSteps}/4 &nbsp; &nbsp; </span>  <span>{completionPercentage}% finished</span> */}
              </CardHeader>
              <CardBody className="step2 body_with_low_padding" data-intro="KYC Documents">
                {dealershipData && <StepZilla
                  steps={[
                    { name: 'Dealership PAN Card', component: <PAN data={dealershipData} refreshPanCard={refreshKyc} /> },
                    { name: 'GST Number', component: <GSTN data={dealershipData} refreshGstnCard={refreshKyc} /> },
                    { name: 'Bank Details', component: <BankDetails data={dealershipData} refreshBankDetailsCard={refreshKyc} /> },
                    { name: 'Authorized Signatory', component: <Aadhar data={dealershipData} receiveFromAadhar={refreshKyc} /> }
                  ]}
                  showSteps={false}
                  showNavigation={true}
                  // startAtStep={
                  //   window.sessionStorage.getItem("step")
                  //     ? parseFloat(window.sessionStorage.getItem("step"))
                  //     : 0
                  // }
                  // onStepChange={step =>
                  //   window.sessionStorage.setItem("step", step)
                  // }
                  stepsNavigation={false}
                  prevBtnOnLastStep={true}
                  dontValidate={false}
                // onStepChange= {(step,e) => {
                //   debugger
                //   if(step === 1 && dealershipData.dealership_kyc_detail.is_pan_verified){
                //      alert('please verify pan');
                //   }
                // }}
                />
                }
              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>

    </Fragment>
  );
};

export default KYCBackup;
